export const findTextElements = shape =>
	shape.text
	&& shape.text.textElements

export const findLinkProperty = shape =>
	shape.shapeProperties
	&& shape.shapeProperties.link
